import { profileType } from "@utils/enum";
import Shipments from "../../../containers/shipments/shipments";
import { globalCountryDetailsDictionary as globalCountryDetails } from "../../../core/global/global-country-details";
import { analyticsTypeDictionary as analyticsType, autoSuggestLanguageDictionary as autosuggestLanguageOptions, categoryType, filterTypeDictionary as filterType, redirectingProfileEnum } from "../../../core/global/global-country-dictionary";
import { getApiUrl } from "../../../utils/baseUrl";
import { allCountryHighlightColumns } from "@utils/highLightColumnMultiCountry";

export const analyticDropdownOptions = [
  { value: "shipments", label: "Number of Shipments", two_table_header: "Total Shipments" },
  { value: "value", label: "Total Shipment Value (USD)", two_table_header: "Total Value (USD)" },
];
export const trendsDropdownOptions = [
  { value: "shipments", label: "Shipments", table_header: "Total Shipments" },
  { value: "value", label: "Value (USD)", table_header: "Total Value (USD)" },
];
export const defaultData = {
  name: "India Imports (Mirror)",
  customShipmentGrid: true,
  showUiUeLevelTwo: true,
  isProductChemicalPresent: true,
  analyticsDefault: analyticDropdownOptions[0].value,
  analyticsRangeDownloadPresent: true,
  isFilterGroupingPresent: true,
  isViewAllGridNew: true,
  isImpExpGraph: true,
  showUiTrends: true,
  isShipmentGridNew: true,
  exportPDFInAnalytics: false,
  minimumDateAllowed: "2020-01-01",
  isUIGridNew: true,
  isUEGridNew: true,
  trendsTableCompanyID: {
    shipper: "hashed_id",
    consignee: "hashed_id",
  },
  importer_exporter_graph_sort__options: [
    { value: "shipment_value", label: "Value (USD)", table_header: "Total Shipment Value(USD)" },
    { value: "doc_count", value1: "date", label: "Shipments", table_header: "Total Shipments" },
  ],
  apiEndPoints: {
    getArrivalDate: getApiUrl("intelSearchIndiaMirrorImportLatestArrivalDate"),
    getSearchResult: getApiUrl("intelSearchIndiaMirrorImport"),
    getAnalyticsData: getApiUrl("analytics/intelAnalyticsIndiaMirrorImport"),
    saveProspectiveExportersApi: "addFavouriteCompany",
    saveProspectiveImportersApi: "addFavouriteCompany",
    downloadShipmentsApi: getApiUrl("create_excel_india_mirror_imports"),
    downloadUniqueImporterExporter: getApiUrl("create_excel_india_mirror_imports"),
    getShipmentByID: getApiUrl("intelSearchIndiaMirrorImportShipmentByID"),
    getShipmentDownloadData: getApiUrl("renderToPdfIndiaImports"),
    renderToPdfAnalytics: getApiUrl("renderToPdfAnalytics"),
    getUserPlanDetails: getApiUrl("getUserCreditsByPlan"),
    getCompanySlug: getApiUrl("companyProfiles/getSlug"),
    getSavedSearchPayloadById: getApiUrl("getSavedSearchPayloadById"),
    getMasterListsForAutoSearchFeilds: getApiUrl("dashboard/getMasterListsForAutoSearchFeilds"),
    getAnalyticsViewAll: getApiUrl("analytics/intelAnalyticsIndiaMirrorImportViewAll"),
    getMissingTabData: getApiUrl("intelSearchWhatAreMissing"),
    getImpExpGraphData: getApiUrl("intelSearchIndiaMirrorImportGraph"),
  },
  isAdvancedSearchAvailable: false,
  country_small: globalCountryDetails.inmr_import.country_small,
  countryCaps: globalCountryDetails.inmr_import.country_caps,
  product_id: globalCountryDetails.inmr_import.product_id,
  compare_product_id: globalCountryDetails.inmr_import.compareProduct,
  country_CamelCase: globalCountryDetails.inmr_import.product_id,
  countryCode: globalCountryDetails.inmr_import.countryCode,
  countryType: globalCountryDetails.inmr_import.countryType,
  manyCountryType: globalCountryDetails.inmr_import.manyCountryType,
  countryTypeCode: globalCountryDetails.inmr_import.countryTypeCode,
  redirectionID: globalCountryDetails.inmr_import.redirectionID,
  analyticsCountryID: globalCountryDetails.inmr_import.analyticsCountryID,
  isMirror: globalCountryDetails.inmr_import.continent,
  autoSuggestLanguage: autosuggestLanguageOptions.english,
  dateRangeHeading: "Shipment Date Range",
  monthRangeHeading: "Month of Import",
  picker: {
    monthPicker: false,
    datePicker: true,
  },
  tabKeyWords: {
    shipments: true,
    analytics: true,
    exporters: true,
    importers: true,
    whatYouAreMissing: true,
  },
  main_dropdown_options: {
    entire_bill_of_lading: false,
    product_description: true,
    product_hscode: true,
    exporters: true,
    importers: true,
    allCategory: true,
    ports: true,
    chemical_description: true,
  },
  searchCategoryList: globalCountryDetails.inmr_import.defaultDropDown,
  specialFields: {
    hscode: "hsCode",
    consignee: "derivedConsigneeMasterName",
    shipper: "derivedShipperMasterName",
    value: "shipmentValue",
    productCategory: "productCategory",
    sixDigitHsCode: "sixDigitHsCode",
    portOfLading: "standardLadingPortRegion",
    portOfUnlading: "standardUnladingPortRegion",
  },
  filterObj: {
    shipperName: "shipperName",
    shipperType: "shipperType",
    originCountryRegion: "originCountryRegion",
    exportCountryRegion: "exportCountryRegion",
    outboundCountryRegion: "outboundCountryRegion",
    consigneeJurisdictionCountryRegion: "consigneeJurisdictionCountryRegion",
    shipperJurisdictionCountryRegion: "shipperJurisdictionCountryRegion",
    countryOfDestinationRegion: "countryOfDestinationRegion",
    inboundCountryRegion: "inboundCountryRegion",
    isExporter: "isExporter",
    isImporter: "isImporter",
    consigneeName: "consigneeName",
    consigneeType: "consigneeType",
    consigneeStateRegion: "consigneeStateRegion",
    consigneeCityRegion: "consigneeCityRegion",
    consigneePincode: "consigneePincode",
    // portOfLadingRegion: 'portOfLadingRegion',
    portOfLading: "portOfLading",
    portOfUnladingRegion: "portOfUnladingRegion",
    customHouseAgentName: "customHouseAgentName",
    hsCode: "hsCode",
    shipmentValue: "shipmentValue",
    modeOfTransport: "modeOfTransport",
    billType: "billType",
    derivedShipperMasterName: "derivedShipperMasterName",
    derivedConsigneeMasterName: "derivedConsigneeMasterName",
    sixDigitHsCode: "sixDigitHsCode",
    productCategory: "productCategory",
    industryCategory: "industryCategory",
    standardLadingPortName: "standardLadingPortName",
    standardLadingPortRegion: "standardLadingPortRegion",
    standardUnladingPortName: "standardUnladingPortName",
    standardUnladingPortRegion: "standardUnladingPortRegion",
    quantityUnit: "quantityUnit",
    perUnitValue: "perUnitValue",
    quantityRange: "quantityRange",
  },
  booleanFilterObj: {
    // include_master_bill: 'include_master_bill',
    exclude_blank_consignee: "exclude_blank_consignee",
    exclude_blank_shipper: "exclude_blank_shipper",
  },
  boxRangeFilterList: {
    shipmentValue: "shipmentValue",
    perUnitValue: "perUnitValue",
    quantityRange: "quantityRange",
  },
  boxFilterObj: {
    shipmentValue: [],
    perUnitValue: [],
    quantityRange: [],
  },
  localisationFilterObj: {
    originCountryRegion: "originCountry",
    outboundCountryRegion: "outboundCountry",
    exportCountryRegion: "exportCountry",
    countryOfDestinationRegion: "countryOfDestination",
    inboundCountryRegion: "inboundCountry",
    isImporter: "isImporter",
    isExporter: "isExporter",
    consigneeJurisdictionCountryRegion: "consigneeJurisdictionCountry",
    shipperJurisdictionCountryRegion: "shipperJurisdictionCountry",
    consigneeCityRegion: "consigneeCity",
    consigneeStateRegion: "consigneeState",
    // portOfLadingRegion: 'portOfLading',
    portOfUnladingRegion: "portOfUnlading",
    standardLadingPortRegion: "standardLadingPortName",
    standardUnladingPortRegion: "standardUnladingPortName",
  },
  emptyFilterObj: {
    shipperName: [],
    shipperType: [],
    originCountryRegion: [],
    outboundCountryRegion: [],
    exportCountryRegion: [],
    countryOfDestinationRegion: [],
    inboundCountryRegion: [],
    isImporter: [],
    isExporter: [],
    consigneeJurisdictionCountryRegion: [],
    shipperJurisdictionCountryRegion: [],
    consigneeName: [],
    consigneeType: [],
    consigneeStateRegion: [],
    consigneeCityRegion: [],
    consigneePincode: [],
    // portOfLadingRegion: [],
    portOfLading: [],
    portOfUnladingRegion: [],
    customHouseAgentName: [],
    hsCode: [],
    sections: [],
    shipmentValue: [],
    modeOfTransport: [],
    billType: [],
    derivedShipperMasterName: [],
    derivedConsigneeMasterName: [],
    sixDigitHsCode: [],
    productCategory: [],
    industryCategory: [],
    standardLadingPortRegion: [],
    standardUnladingPortRegion: [],
    quantityUnit: [],
    perUnitValue: [],
    quantityRange: [],
  },
  defaultBooleanFilterObj: {
    // include_master_bill: true,
    exclude_blank_consignee: false,
    exclude_blank_shipper: false,
  },
  selectAll: {
    shipperName: false,
    shipperType: false,
    originCountryRegion: false,
    outboundCountryRegion: false,
    exportCountryRegion: false,
    countryOfDestinationRegion: false,
    inboundCountryRegion: false,
    isImporter: false,
    isExporter: false,
    consigneeJurisdictionCountryRegion: false,
    shipperJurisdictionCountryRegion: false,
    consigneeName: false,
    consigneeType: false,
    consigneeStateRegion: false,
    consigneeCityRegion: false,
    consigneePincode: false,
    // portOfLadingRegion: false,
    portOfLading: false,
    portOfUnladingRegion: false,
    customHouseAgentName: false,
    hsCode: false,
    sections: false,
    shipmentValue: false,
    modeOfTransport: false,
    billType: false,
    derivedShipperMasterName: false,
    derivedConsigneeMasterName: false,
    sixDigitHsCode: false,
    productCategory: false,
    industryCategory: false,
    standardLadingPortRegion: false,
    standardUnladingPortRegion: false,
    quantityUnit: false,
    perUnitValue: false,
    quantityRange: false,
  },
  specialMappingFields: {
    derived_hs_codes_string: {
      derived_hs_codes_string: {
        key: "derived_hs_codes_string",
        value: "",
      },
      derived_hs_codes_string_estimated: {
        key: "derived_hs_codes_string_estimated",
        value: "",
      },
      derived_hs_codes_string_estimated_is_present: {
        key: "derived_hs_codes_string_estimated_is_present",
        value: "Estimated HSCode",
      },
      fallback: "Not Available",
    },
    derived_shipment_value: {
      derived_shipment_value: {
        key: "derived_shipment_value",
        value: "",
      },
      derived_shipment_value_is_present: {
        key: "derived_shipment_value_is_present",
        value: "",
      },
      fallback: "Not Available",
    },
    shipper_party_name: {
      shipper_party_name: {
        key: "shipper_party_name",
        value: "",
      },
      fallback: "Not Declared",
    },
  },
  normalfilterList: [
    { heading: "Filter by Shipper Standardized Name", categoryName: "shipperDetails", eventKey: "18", key: "derivedShipperMasterName", type: filterType.normalFilter, label: "Shipper Standardized Name", viewAllPlaceHolder: "Search in Shipper Standardized Name Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Consignee Standardized Name", categoryName: "consigneeDetails", eventKey: "19", key: "derivedConsigneeMasterName", type: filterType.normalFilter, label: "Consignee Standardized Name", viewAllPlaceHolder: "Search in Consignee Standardized Name Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Shipper Name", categoryName: "shipperDetails", eventKey: "1", key: "shipperName", type: filterType.normalFilter, label: "Shipper Name", viewAllPlaceHolder: "Search in Shipper Name Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Consignee Name", categoryName: "consigneeDetails", eventKey: "5", key: "consigneeName", type: filterType.normalFilter, label: "Consignee Name", viewAllPlaceHolder: "Search in Consignee Name Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Shipper Type", categoryName: "shipperDetails", eventKey: "2", key: "isExporter", type: filterType.normalFilter, label: "Shipper Type", viewAllPlaceHolder: "Search in Shipper Type Filter", emptyFilterText: "", searchFilterString: "" },
    // { heading: "Filter by Country Of Origin", categoryName: "shipperDetails", eventKey: "3", key: "originCountryRegion", altKey: "originCountry", type: filterType.localizeFilter, label: "Country Of Origin", viewAllPlaceHolder: "Search in Country Of Origin Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Country of Export", categoryName: "shipperDetails", eventKey: "4", key: "outboundCountryRegion", altKey: "outboundCountry", type: filterType.localizeFilter, label: "Country of Export", viewAllPlaceHolder: "Search in Country of Export Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Consignee Jurisdiction Country", categoryName: categoryType.consigneeDetails, eventKey: "25", key: "consigneeJurisdictionCountryRegion", altKey: "consigneeJurisdictionCountry", type: filterType.localizeFilter, label: "Consignee Jurisdiction Country", viewAllPlaceHolder: "Search Consignee Jurisdiction Country", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Shipper Jurisdiction Country", categoryName: categoryType.shipperDetails, eventKey: "25", key: "shipperJurisdictionCountryRegion", altKey: "shipperJurisdictionCountry", type: filterType.localizeFilter, label: "Shipper Jurisdiction Country", viewAllPlaceHolder: "Search Shipper Jurisdiction Country", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Country of Import", categoryName: "consigneeDetails", eventKey: "4", key: "inboundCountryRegion", altKey: "inboundCountry", type: filterType.localizeFilter, label: "Country of Import", viewAllPlaceHolder: "Search in Country of Import Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Consignee Type", categoryName: "consigneeDetails", eventKey: "6", key: "isImporter", type: filterType.normalFilter, label: "Consignee Type", viewAllPlaceHolder: "Search in Consignee Type Filter", emptyFilterText: "", searchFilterString: "" },
    // { heading: "Filter by Consignee State", categoryName: "consigneeDetails", eventKey: "7", key: "consigneeStateRegion", altKey: "consigneeState", type: filterType.localizeFilter, label: "Consignee State", viewAllPlaceHolder: "Search in Consignee State", emptyFilterText: "", searchFilterString: "" },
    // { heading: "Filter by Consignee City", categoryName: "consigneeDetails", eventKey: "8", key: "consigneeCityRegion", altKey: "consigneeCity", type: filterType.localizeFilter, label: "Consignee City", viewAllPlaceHolder: "Search in Consignee City Filter", emptyFilterText: "", searchFilterString: "" },
    // { heading: "Filter by Consignee Pincode", categoryName: "consigneeDetails", eventKey: "9", key: "consigneePincode", type: filterType.normalFilter, label: "Consignee Pincode", viewAllPlaceHolder: "Search in Consignee Pincode Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Port Of Lading", categoryName: "ports", eventKey: "10", key: "standardLadingPortRegion", altKey: "standardLadingPortName", type: filterType.localizeFilter, label: "Port Of Lading", viewAllPlaceHolder: "Search in Port Of Lading Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Port Of Unlading", categoryName: "ports", eventKey: "11", key: "standardUnladingPortRegion", altKey: "standardUnladingPortName", type: filterType.localizeFilter, label: "Port Of Unlading", viewAllPlaceHolder: "Search in Port Of Unlading Filter", emptyFilterText: "", searchFilterString: "" },
    // { heading: "Filter by Customs House Agent Name", categoryName: "customsDetails", eventKey: "12", key: "customHouseAgentName", type: filterType.normalFilter, label: "Customs House Agent Name", viewAllPlaceHolder: "Search in Customs House Agent Name Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Product Category", categoryName: "cargoDetails", eventKey: "13", key: "productCategory", type: filterType.normalFilter, label: "Product Category", viewAllPlaceHolder: "Search in Product Category Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Industry Group", categoryName: "cargoDetails", eventKey: "33", key: "industryCategory", type: filterType.normalFilter, label: "Industry Group", viewAllPlaceHolder: "Search in Industry Group Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by HS Code", categoryName: "cargoDetails", eventKey: "13", key: "hsCode", type: filterType.hsCodeFilter, label: "HS Code", viewAllPlaceHolder: "Search in HS Code Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Shipment Value", categoryName: "cargoDetails", eventKey: "15", key: "shipmentValue", type: filterType.boxFilter, label: "Shipment Value (USD)", viewAllPlaceHolder: "Search in Value Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Mode of Transportation", categoryName: "freightType", eventKey: "16", key: "modeOfTransport", type: filterType.normalFilter, label: "Mode of Transportation", viewAllPlaceHolder: "Search in Mode of Transportation Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by 6 digit HS Code", categoryName: "cargoDetails", eventKey: "9", key: "sixDigitHsCode", type: filterType.normalFilter, label: "6 Digit HS Code", viewAllPlaceHolder: "Type to Search 6 digit HS Code", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Quantity Unit", categoryName: "cargoDetails", eventKey: "32", key: "quantityUnit", additionalKey: "quantityRange", type: filterType.normalFilter, label: "Quantity", viewAllPlaceHolder: "Search Quantity Unit", emptyFilterText: "", searchFilterString: "", infoText: "", showInput: true, isParanthesesCapital: false, additionalType: "multiSelectRangeFilter" },
    { heading: "Filter by Per Unit Value (USD)", categoryName: categoryType.cargoDetails, eventKey: "32", key: "perUnitValue", type: filterType.multiSelectRangeFilter, label: "Per Unit Value (USD)", viewAllPlaceHolder: "", emptyFilterText: "", searchFilterString: "", infoText: "", showInput: false, isParanthesesCapital: false },
  ],
  internalFilterList: [
    { isVisible: true, key: "uniqueImportExporterShipment" },
    { isVisible: false, key: "uniqueImportExporterWeight" },
    { isVisible: false, key: "uniqueImportExporterTeu" },
    { isVisible: true, key: "uniqueImportExporterValue" },
  ],
  highLightedColumnList: [...allCountryHighlightColumns],
  shipmentSorting: [
    { columnKey: "derived_bill_of_entry_date", value: "date", isDefault: true },
    { columnKey: "derived_shipment_value_usd", value: "shipment_value", isDefault: false },
  ],
  exporterSorting: [
    { name: "Shipment Value", columnKey: "shipment_value", value: "shipment_value", isDefault: false },
    { name: "Shipments", columnKey: "doc_count", value: "date", isDefault: true },
  ],
  importerSorting: [
    { name: "Shipment Value", columnKey: "shipment_value", value: "shipment_value", isDefault: false },
    { name: "Shipments", columnKey: "doc_count", value: "date", isDefault: true },
  ],
  sortKeyMap: {
    date: "derived_bill_of_entry_date",
    shipment_value: "derived_shipment_value_usd",
  },
  sortKeyUniqueImpExpMap: {
    shipment_value: "shipment_value",
    date: "doc_count",
  },
  analyticsHeaderItems: [
    { label: "Total Number of Shipments", key: "total_shipments", valuePrefix: "", valueSuffix: "" },
    { label: "Total Shipment Value (USD)", key: "total_value", valuePrefix: "USD", valueSuffix: "" },
  ],
  analyticsFieldsMapping: [
    { key: "mirror_trends", filterKey: "", label: "Import Trends", type: analyticsType.trends, showTrends: true, showlevelTwo: false, modalHeader: "Import Trends" },
    { key: "trade_country_of_export_to_import", filterKey1: "outboundCountryRegion", filterKey2: "inboundCountryRegion", label: "Trade Routes (Country of Export → Country of Import)", headerOne: "Country of Export", headerTwo: "Country of Import", filterOne: "filterField1", filterTwo: "filterField2", keyOne: "field1Country", keyTwo: "field2Country", cityOne: "field1", cityTwo: "field2", keyOneCountryCode: "field1CountryCode", keyTwoCountryCode: "field2CountryCode", type: analyticsType.topTwo, showTrends: true, grpType: "multi", showlevelTwo: true, defaultKey: "derived_consignee_master_name" },
    { key: "country_of_origin", filterKey: "originCountryRegion", label: "Countries of Origin", type: analyticsType.horizontalCountry, showTrends: true, showlevelTwo: true, defaultKey: "port_of_unlading" },
    { key: "port_of_lading", filterKey: "standardLadingPortRegion", label: "Ports of Lading", type: analyticsType.horizontalBar, showTrends: true, showlevelTwo: true, defaultKey: "port_of_unlading", profileType: redirectingProfileEnum.portOfLading.key, isFavourite: true, profileTypeKey: profileType.ports },
    { key: "port_of_unlading", filterKey: "standardUnladingPortRegion", label: "Ports of Unlading", type: analyticsType.horizontalBar, showTrends: true, showlevelTwo: true, defaultKey: "port_of_lading", profileType: redirectingProfileEnum.portOfUnlading.key, isFavourite: true, profileTypeKey: profileType.ports },
    // { key: "consignee_state", filterKey: "consigneeStateRegion", label: "Consignee States", type: analyticsType.horizontalBar, showTrends: true, showlevelTwo: true, defaultKey: "country_of_origin" },
    // { key: "consignee_city", filterKey: "consigneeCityRegion", label: "Consignee Cities", type: analyticsType.horizontalBar, showTrends: true, showlevelTwo: true, defaultKey: "country_of_origin" },
    // { key: "custom_house", filterKey: "customHouseAgentName", label: "Customs House Agent Name", type: analyticsType.horizontalBar, showTrends: true, showlevelTwo: true, defaultKey: "port_of_unlading" },
    { key: "mode_of_transport", filterKey: "modeOfTransport", label: "Modes of Transportation", type: analyticsType.pieChart, showTrends: true, showlevelTwo: true, defaultKey: "port_of_unlading" },
    { key: "hs_code", headerLabel: "HS Code", filterKey: "hsCode", label: "2-digit HS Codes", type: analyticsType.hsCode, showTrends: false, showlevelTwo: false },
    // { key: "trade_route_coo_unlading", filterKey1: "originCountryRegion", filterKey2: "standardUnladingPortRegion", label: "Trade Routes (Country of Origin → Port of Unlading)", headerOne: "Country of Origin", headerTwo: "Port of Unlading", filterOne: "filterField1", filterTwo: "filterField2", keyOne: "field1Country", cityOne: "field1", cityTwo: "field2", keyOneCountryCode: "field1CountryCode", keyTwo: "field2Country", keyTwoCountryCode: "field2CountryCode", type: analyticsType.topTwo, showTrends: true, grpType: "multi", showlevelTwo: true, defaultKey: "derived_consignee_master_name" },
    { key: "trade_route_lading_unlading", filterKey1: "standardLadingPortRegion", filterKey2: "standardUnladingPortRegion", label: "Trade Routes (Port of Lading → Port of Unlading)", headerOne: "Port of Lading", headerTwo: "Port of Unlading", filterOne: "filterField1", filterTwo: "filterField2", keyOne: "field1Country", cityOne: "field1", cityTwo: "field2", keyOneCountryCode: "field1CountryCode", keyTwo: "field2Country", keyTwoCountryCode: "field2CountryCode", type: analyticsType.topTwo, showTrends: true, grpType: "multi", showlevelTwo: true, defaultKey: "derived_consignee_master_name" },
    // { key: "trade_route_shipper_country_consignee_state", filterKey1: "exportCountryRegion", filterKey2: "consigneeStateRegion", label: "Trade Routes (Country of Export → Consignee State)", headerOne: "Country of Export", headerTwo: "Consignee State", filterOne: "filterField1", filterTwo: "filterField2", keyOne: "field1Country", cityOne: "field1", cityTwo: "field2", keyOneCountryCode: "field1CountryCode", keyTwo: "field2Country", keyTwoCountryCode: "field2CountryCode", type: analyticsType.topTwo, showTrends: true, grpType: "multi", showlevelTwo: true, defaultKey: "derived_consignee_master_name" },
    // { key: "trade_route_coo_lading_unlading", filterKey1: "originCountryRegion", filterKey2: "standardLadingPortRegion", filterKey3: "standardUnladingPortRegion", label: "Trade Routes (Country of Origin → Port of Lading → Port of Unlading)", filterOne: "filterField1", filterTwo: "filterField2", filterThree: "filterField3", headerOne: "Country of Origin", headerTwo: "Port Of Lading", headerThree: "Port Of Unlading", keyOne: "field1Country", keyTwo: "field2Country", keyThree: "field3Country", cityOne: "field1", cityTwo: "field2", cityThree: "field3", keyOneCountryCode: "field1CountryCode", keyTwoCountryCode: "field2CountryCode", keyThreeCountryCode: "field3CountryCode", type: analyticsType.topThree, grpType: "multi", showTrends: true, showlevelTwo: true, defaultKey: "derived_consignee_master_name" },
    { key: "six_digit_hs_code", headerLabel: "6 digit HS Code", filterKey: "sixDigitHsCode", label: "6 digit HS Codes", type: analyticsType.hsCode, showTrends: true, showlevelTwo: true, defaultKey: "derived_consignee_master_name" },
  ],
  searchTableColumns: [
    { key: "", name: "View", selector: "", dataTip: "", type: "viewShipment", button: true, staticField: true, grow: 0, miWidth: "40px", maWidth: "40px" },
    { key: "s_no", name: "S No", selector: "s_no", dataTip: "", type: "", maxWidth: "84px !important", minWidth: "84px !important", grow: 0, wrap: true, staticField: true, miWidth: "60px", maWidth: "60px" },
    { key: "derived_bill_of_entry_date", name: "Shipment Date", selector: "derived_bill_of_entry_date", dataTip: "", type: "", dateFormat: "MMM DD, YYYY", sortable: true, grow: 1, wrap: true, miWidth: "120px", maWidth: "120px" },
    { key: "matched_column", name: "Matching Fields", selector: "matched_column", dataTip: "", type: "matchingField", grow: 1, wrap: true, miWidth: "120px", maWidth: "120px" },
    { key: "hs_code", name: "HS Code", selector: "hs_code", dataTip: "", type: "", grow: 1, wrap: true, miWidth: "100px", maWidth: "100px" },
    { key: "product_description", name: "Product Description", selector: "product_description", tooltipValue: "product_description", type: "", grow: 2, wrap: true, isSliceEnabled: true, sliceLength: 30, miWidth: "120px", maWidth: "120px" },
    { key: "quantity", name: "Quantity", selector: "quantity", secondarySelector: "derived_quantity_unit", dataTip: "", type: "", grow: 0, wrap: true, isCommaFormat: true, fixedValueUpto: 2, miWidth: "100px", maWidth: "100px" },
    { key: "derived_consignee_master_name", name: "Consignee Name", selector: "derived_consignee_master_name", alternateSelector: "importer_name", id: "derived_consignee_master_company_id", dataTip: "", type: "companyRedirect", companyType: "I", grow: 1, wrap: true, miWidth: "120px", maWidth: "120px" },
    { key: "derived_shipper_master_name", name: "Shipper Name", selector: "derived_shipper_master_name", alternateSelector: "shipper_name", id: "derived_shipper_master_company_id", dataTip: "", type: "companyRedirect", companyType: "E", grow: 1, wrap: true, miWidth: "120px", maWidth: "120px" },
    { key: "derived_country_of_origin", name: "Country Of Origin", selector: "derived_country_of_origin", dataTip: "", type: "", grow: 1, wrap: true, miWidth: "120px", maWidth: "120px" },
    { key: "derived_shipment_value_usd", name: "Shipment Value (USD)", selector: "derived_shipment_value_usd", dataTip: "", type: "", sortable: true, grow: 1, wrap: true, isCommaFormat: true, fixedValueUpto: 2, miWidth: "140px", maWidth: "140px" },
  ],
  exporterTableColumn: [
    { key: "id", showUiUeTwoLevel: false, name: "S No.", selector: "id", dataTip: "", type: "", button: true, staticField: true },
    { key: "key", name: "Company Name", selector: "key", selector1: "country", selector1Code: "country_code", selector2: "state", selector3: "address", id: "hashed_id", type: "companyRedirect", fixedLengthUptoRank: 30, fixedLengthUptoTrend: 28, minWidth: "275px" },
    { key: "subKey", showUiUeTwoLevel: true, name: "Random Table", selector: "subKey", grow: 1, wrap: true },
    { key: "doc_count", name: "Shipments", selector: "doc_count", sortable: true, dataTip: "", type: "", grow: 1, wrap: true, isCommaFormat: true },
    { key: "shipment_value", name: "Shipment Value (USD)", selector: "shipment_value", sortable: true, dataTip: "", type: "", isCommaFormat: true, fixedValueUpto: 2 },
    { key: "oldest_shipment_date", name: "First Exported On", selector: "oldest_shipment_date", grow: 1, wrap: true },
    { key: "recent_shipment_date", name: "Last Exported On", selector: "recent_shipment_date", grow: 1, wrap: true },
    { key: "market_share", showUiUeTwoLevel: true, isNameVariable: true, name: "% share by", selector: "market_share", type: "", grow: 1, wrap: true },
  ],
  importerTableColumn: [
    { key: "id", showUiUeTwoLevel: false, name: "S No.", selector: "id", dataTip: "", type: "", button: true, staticField: true },
    {
      key: "key",
      name: "Company Name",
      subProperties: [
        {
          className: "tw-bg-gray-200 tw-font-medium tw-border tw-rounded-[14px] tw-py-[3.2px] tw-px-2 tw-h-fit",
          selector: "iec_number",
        },
      ],
      selector: "key",
      selector1: "country",
      selector1Code: "country_code",
      selector2: "state",
      selector3: "address",
      id: "hashed_id",
      type: "companyRedirect",
      fixedLengthUptoRank: 30,
      fixedLengthUptoTrend: 28,
      minWidth: "275px",
    },
    { key: "subKey", showUiUeTwoLevel: true, name: "Random Table", selector: "subKey", grow: 1, wrap: true },
    { key: "doc_count", name: "Shipments", selector: "doc_count", sortable: true, dataTip: "", type: "", grow: 1, wrap: true, isCommaFormat: true },
    { key: "shipment_value", name: "Shipment Value (USD)", selector: "shipment_value", sortable: true, dataTip: "", type: "", isCommaFormat: true, fixedValueUpto: 2 },
    { key: "oldest_shipment_date", name: "First Imported On", selector: "oldest_shipment_date", grow: 1, wrap: true },
    { key: "recent_shipment_date", name: "Last Imported On", selector: "recent_shipment_date", grow: 1, wrap: true },
    { key: "market_share", showUiUeTwoLevel: true, isNameVariable: true, name: "% share by", selector: "market_share", type: "", grow: 1, wrap: true },
  ],
  viewShipmentDetails: [
    {
      id: 1,
      title: "",
      growValue: 12,
      isHeader: true,
      imgUrl: "",
      data: [
        { label: "Shipment Date", value: "derived_bill_of_entry_date", dateFormat: true, monthFormat: false },
        { label: "HS Code", value: "derived_hs_code" },
        { label: "Item Number", value: "item_number" },
        // { label: "Invoice Number", value: "invoice_number" },
        { label: "Mode of Transportation", value: "derived_mode_of_transport" },
      ],
    },
    {
      id: 2,
      title: "Shipment Origin Details",
      isConnectedColumn: true,
      isCompactHeader: true,
      growValue: 6,
      isHeader: false,
      imgUrl: "",
      data: [
        { label: "Country of Origin", value: "derived_country_of_origin" },
        { label: "Port of Lading", value: "derived_port_of_lading", type: "redirect", redirectionID: "derived_port_of_lading_master_id", profileType: redirectingProfileEnum.portOfLading.key },
        { label: "Shipper Name", value: "shipper_name" },
        { label: "Shipper Standardized Name", type: "redirect", companyIdKey: "derived_shipper_master_company_id", companyKey: "", derivedCompanyKey: "derived_shipper_master_name", tradeDirection: "E" },
        { label: "Shipper Type", value: "derived_is_exporter", tooltip: false, tooltipField: "" },
        { label: "Country of Export", value: "derived_country_of_export", countryFlag: true, countryCodeField: "derived_country_of_export_code" },
        { label: "Shipper Address", value: "shipper_address", isReadMore: true, readMoreLength: 45 },
        { label: "Shipper Jurisdiction Country", value: "derived_shipper_jurisdiction_country", countryFlag: true, countryCodeField: "derived_shipper_jurisdiction_country_code" },
      ],
    },
    {
      id: 3,
      title: "Shipment Destination Details",
      growValue: 6,
      isHeader: false,
      isCompactHeader: true,
      imgUrl: "",
      data: [
        { label: "Port of Unlading", value: "derived_port_of_unlading", tooltip: true, tooltipField: "derived_port_of_unlading_code", tooltipPrefix: "Port Code: ", type: "redirect", redirectionID: "derived_port_of_unlading_master_id", profileType: redirectingProfileEnum.portOfUnlading.key },
        // { label: 'Importer ID', value: 'derived_importer_id', isCapitalise: true, },
        { label: "Consignee Name", value: "importer_name" },
        { label: "IEC Number", value: "derived_importer_id", preValidate: true, isIecField: true },
        { label: "Country of Import", value: "derived_country_of_import", countryFlag: true, countryCodeField: "derived_country_of_import_code" },
        { label: "Consignee Standardized Name", type: "redirect", companyIdKey: "derived_consignee_master_company_id", companyKey: "", derivedCompanyKey: "derived_consignee_master_name", tradeDirection: "I" },
        { label: "Consignee Type", value: "derived_is_importer" },
        { label: "Consignee State", value: "derived_importer_state" },
        { label: "Consignee City", value: "derived_importer_city" },
        { label: "Consignee Pincode", value: "derived_importer_pincode" },
        { label: "Consignee Address", value: "importer_address", isReadMore: true, readMoreLength: 45 },
        { label: "Consignee Phone Number", value: "importer_contact_number" },
        { label: "Consignee Email ID", value: "importer_email_id" },
        { label: "Consignee Jurisdiction Country", value: "derived_consignee_jurisdiction_country", countryFlag: true, countryCodeField: "derived_consignee_jurisdiction_country_code" },
      ],
    },
    // {
    //   id: 4,
    //   title: "Customs Details",
    //   growValue: 6,
    //   isHeader: false,
    //   imgUrl: "https://res.cloudinary.com/ddfycftwg/image/upload/v1640251816/images/website/api-integration/ship-gray_1_jqiqaq.svg",
    //   data: [
    //     { label: "Custom House Agent Code", value: "derived_customs_house_agent_code", isCapitalise: true },
    //     { label: "Custom House Agent Name", value: "customs_house_agent_name", isCapitalise: true },
    //   ],
    // },
    // {
    //     id: 5,
    //     title: "Carrier Details",
    //     growValue: 6,
    //     isHeader: false,
    //     imgUrl: "https://res.cloudinary.com/ddfycftwg/image/upload/v1640251778/images/website/api-integration/delivery-box_1_1_niaysj.svg",
    //     data: [
    //         { label: 'Vessel Name', value: 'vessel_name', isCapitalise: 'true', },
    //     ],
    // },
    {
      id: 5,
      title: "Cargo Details",
      growValue: 6,
      isHeader: false,
      imgUrl: "https://res.cloudinary.com/ddfycftwg/image/upload/v1640251778/images/website/api-integration/delivery-box_1_1_niaysj.svg",
      data: [
        { label: "HS Code", value: "hs_code" },
        { label: "Product Description", value: "product_description" },
        { label: "Quantity", value: "quantity", dynamicUnit: true, unitField: "derived_quantity_unit", isCommaFormat: true },
        { label: "Shipment Value ", value: "derived_shipment_value_usd", valuePrefix: "USD ", isCommaFormat: true, tooltip: true, tooltipField: "shipment_value_inr", tooltipPrefix: "INR " },
        { label: "Per Unit Value", value: "derived_shipment_value_usd_per_quantity_unit", valuePrefix: "USD ", isCommaFormat: true },
        { label: "Duty Paid", value: "derived_duty_paid_usd", valuePrefix: "USD ", isCommaFormat: true, tooltip: true, tooltipField: "duty_paid_inr", tooltipPrefix: "INR " },
      ],
    },
  ],
  onboardingSteps: [
    { selector: "#reacttourdaterange", disableInteraction: true, header: "", description: "Customize your shipment basis payment date", float: "", position: "left" },
    { selector: "#reacttourFilter", disableInteraction: true, header: "Filters Button", description: "Use filters to get most relevant shipments for you", float: "right", position: "right" },
    { selector: "#reacttourMainSearch", disableInteraction: true, header: "Start searching for India Imports Shipments", description: "HS Codes and Consignees", float: "right", position: "bottom" },
    { selector: "#nav-tab", disableInteraction: true, header: "", description: "View unique consignees and shippers in the search result and add them to your prospect list.", float: "right", position: "bottom" },
    { selector: ".saved-search-button", disableInteraction: true, header: "", description: "Reload from Saved Searches, for quick shipments data access.", float: "", position: "bottom" },
  ],
  defaultUeUiSecondLevelKey: "derived_shipper_master_name",
  twoColumnMapping: {
    derived_consignee_master_name: "Unique Importers",
    derived_shipper_master_name: "Unique Exporters",
    // country_of_origin: "Countries of Origin",
    port_of_lading: "Ports of Lading",
    port_of_unlading: "Ports of Unlading",
    // consignee_state: "Consignee States",
    // consignee_city: "Consignee Cities",
    // custom_house: "Custom House Agent Name",
    mode_of_transport: "Mode of Transportation",
    // four_digit_hs_code: "4 Digit HS Codes",
    six_digit_hs_code: "6 digit HS Codes",
    // trade_route_coo_unlading: "Trade Routes (Country of Origin → Port of Unlading)",
    trade_route_lading_unlading: "Trade Routes (Port of Lading → Port of Unlading)",
    trade_country_of_export_to_import: "Trade Routes (Country of Export → Country of Import)",
    // trade_route_shipper_country_consignee_state: "Trade Routes (Country of Export → Consignee State)",
    // trade_route_coo_lading_unlading: "Trade Routes (Country of Origin → Port of Lading → Port of Unlading)",
  },
};

const IndiaImportSearch = () => {
  return <Shipments defaultData={defaultData} analyticDropdownOptions={analyticDropdownOptions} trendsDropdownOptions={trendsDropdownOptions} />;
};
export default IndiaImportSearch;
